import { resolveComponent as p, openBlock as t, createElementBlock as n, createElementVNode as r, renderSlot as x, createVNode as l, toDisplayString as _, createCommentVNode as f, normalizeClass as h, resolveDirective as B, Transition as v, withCtx as c, withDirectives as C, Fragment as b, renderList as D, createBlock as u, resolveDynamicComponent as N, createTextVNode as E, vShow as M } from "vue";
import { _ as m } from "./_plugin-vue_export-helper-dad06003.js";
import { C as A } from "./ChevronDownIcon-461d1eb9.js";
import { a as L, D as P, b as V } from "./DropdownDivider-c57dbbbe.js";
import { B as z } from "./ButtonCloseSm-209b27c6.js";
import "./CardVideo-d193ca09.js";
import "./glightbox-13d8fc52.js";
import "./FormRichText.model-53e072ea.js";
import "./CheckIcon-91388c05.js";
import "./PreloaderIcon-b44be854.js";
import "./XIcon-e21df3cc.js";
import "./HelpIcon-2069ddad.js";
import "./ButtonPlay-d3872713.js";
import "./SlideDownTransition-6bc064ec.js";
import "./useNotificationHandler.js";
import "./DownloadFileIcon-8a003268.js";
import "./BarProgressMd-c3ebb73b.js";
import "./ChevronLeftIcon-b6affe9b.js";
import "./_commonjsHelpers-10dfc225.js";
const T = {
  components: {
    ChevronDownIcon: A
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    value: {
      type: String,
      default: ""
    }
  }
}, j = {
  type: "button",
  class: "ct-nav-item-1 group w-full py-2.5 px-3 flex items-center space-x-2 rounded-md hover:ct-bg-2"
}, F = { class: "ct-nav-item-1__main flex-1 flex items-center space-x-2 text-sm font-medium ct-text-2 group-hover:ct-text-2--hover" }, q = {
  key: 0,
  class: "text-xs ct-text-4"
};
function G(e, i, s, g, k, a) {
  const y = p("ChevronDownIcon");
  return t(), n("button", j, [
    r("div", F, [
      x(e.$slots, "default")
    ]),
    l(y, { class: "ct-nav-item-1__toggle" }),
    s.value ? (t(), n("p", q, _(s.value), 1)) : f("", !0)
  ]);
}
const H = /* @__PURE__ */ m(T, [["render", G]]), J = {}, K = {
  type: "button",
  class: "ct-nav-item-2 group w-full py-2.5 px-3 flex items-center space-x-2 rounded-md hover:ct-bg-2"
}, Q = { class: "pl-8 text-sm ct-text-2 group-hover:ct-text-2--hover flex items-center space-x-2" };
function R(e, i) {
  return t(), n("button", K, [
    r("div", Q, [
      x(e.$slots, "default")
    ])
  ]);
}
const U = /* @__PURE__ */ m(J, [["render", R]]), W = {}, X = { class: "p-3" };
function Y(e, i) {
  return t(), n("div", X, i[0] || (i[0] = [
    r("span", { class: "w-full h-0 border ct-border-2 border-dashed block" }, null, -1)
  ]));
}
const Z = /* @__PURE__ */ m(W, [["render", Y]]), ee = {
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    }
  }
};
function te(e, i, s, g, k, a) {
  return t(), n("div", {
    class: h(["ct-nav-section", { "is-open": s.isOpen }])
  }, [
    x(e.$slots, "default", { isOpen: s.isOpen })
  ], 2);
}
const oe = /* @__PURE__ */ m(ee, [["render", te]]), ne = {
  name: "NavbarSidebar",
  components: {
    DropdownList: L,
    DropdownItem: P,
    DropdownDivider: V,
    NavbarPrimaryItem: H,
    ButtonCloseSm: z,
    NavbarDivider: Z,
    NavbarSecondaryItem: U,
    NavbarSection: oe
  },
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    header: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    breakpoint: {
      type: String,
      default: "lg"
    }
  },
  emits: ["update:open", "toggleCategory"],
  computed: {
    showMenu: {
      get() {
        return this.open;
      },
      set(e) {
        this.$emit("update:open", e);
      }
    }
  },
  watch: {
    showMenu(e) {
      e ? document.addEventListener("keydown", this.closeOnEsc, !0) : document.removeEventListener("keydown", this.closeOnEsc, !0);
    }
  },
  methods: {
    hide() {
      this.showMenu = !1;
    },
    closeAndDo(e) {
      e && e(), this.hide();
    },
    toggleCategory(e) {
      e.isOpen = !e.isOpen, this.$emit("toggleCategory", e);
    },
    closeOnEsc(e) {
      e.key === "Escape" && (e.stopImmediatePropagation(), e.preventDefault(), this.hide());
    }
  }
}, se = {
  key: 0,
  class: "fixed inset-0 ct-bg-overlay"
}, ae = { class: "fixed inset-0 flex" }, re = {
  key: 0,
  class: "relative mr-16 flex w-full max-w-xs flex-1"
}, ce = {
  key: 0,
  class: "absolute left-full top-0 flex w-16 justify-center pt-5"
}, le = { class: "flex grow flex-col ct-bg-1 lg:ct-bg-2--alt overflow-y-auto" }, ie = { class: "flex-shrink-0 flex items-center h-16 ct-text-1 border-b ct-border-2" }, de = { class: "pl-3 pr-5 w-full flex items-center space-x-2" }, ue = {
  key: 0,
  class: "flex-grow text-base font-medium ct-text-1"
}, pe = { class: "mt-2 px-2" };
function _e(e, i, s, g, k, a) {
  const y = p("ButtonCloseSm"), S = p("NavbarDivider"), w = p("NavbarPrimaryItem"), $ = p("NavbarSecondaryItem"), I = p("NavbarSection"), O = B("click-outside");
  return t(), n("div", {
    class: h(["relative z-50", { "lg:hidden": s.breakpoint === "lg", "xl:hidden": s.breakpoint === "xl" }]),
    role: "dialog",
    "aria-modal": "true"
  }, [
    l(v, { name: "fade-linear" }, {
      default: c(() => [
        a.showMenu ? (t(), n("div", se)) : f("", !0)
      ]),
      _: 1
    }),
    l(v, { name: "pretend-transition" }, {
      default: c(() => [
        C(r("div", ae, [
          l(v, { name: "slide" }, {
            default: c(() => [
              a.showMenu ? (t(), n("div", re, [
                l(v, { name: "fade" }, {
                  default: c(() => [
                    a.showMenu ? (t(), n("div", ce, [
                      l(y, { onClick: a.hide }, null, 8, ["onClick"])
                    ])) : f("", !0)
                  ]),
                  _: 1
                }),
                C((t(), n("div", le, [
                  r("div", ie, [
                    r("div", de, [
                      s.header ? (t(), n("p", ue, _(s.header), 1)) : x(e.$slots, "header", { key: 1 })
                    ])
                  ]),
                  r("div", pe, [
                    (t(!0), n(b, null, D(s.items, (o) => (t(), n("div", {
                      key: o.label
                    }, [
                      o.isDivider ? (t(), u(S, { key: 0 })) : (t(), n(b, { key: 1 }, [
                        o.children && o.children.length ? (t(), u(I, {
                          key: 0,
                          "is-open": o.isOpen
                        }, {
                          default: c(() => [
                            l(w, {
                              value: o.value,
                              onClick: (d) => a.toggleCategory(o)
                            }, {
                              default: c(() => [
                                (t(), u(N(o.icon))),
                                r("span", null, _(o.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "onClick"]),
                            (t(!0), n(b, null, D(o.children, (d) => (t(), u($, {
                              key: d.label,
                              class: h({ "is-active": d.active }),
                              onClick: (me) => a.closeAndDo(d.handler)
                            }, {
                              default: c(() => [
                                E(_(d.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "onClick"]))), 128))
                          ]),
                          _: 2
                        }, 1032, ["is-open"])) : (t(), u(w, {
                          key: 1,
                          class: h({
                            "is-active": o.active,
                            "is-danger": o.isDanger
                          }),
                          value: o.value,
                          onClick: (d) => a.closeAndDo(o.handler)
                        }, {
                          default: c(() => [
                            (t(), u(N(o.icon))),
                            r("span", null, _(o.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "value", "onClick"]))
                      ], 64))
                    ]))), 128))
                  ])
                ])), [
                  [O, a.hide]
                ])
              ])) : f("", !0)
            ]),
            _: 3
          })
        ], 512), [
          [M, a.showMenu]
        ])
      ]),
      _: 3
    })
  ], 2);
}
const Ae = /* @__PURE__ */ m(ne, [["render", _e]]);
export {
  Z as NavbarDivider,
  H as NavbarPrimaryItem,
  U as NavbarSecondaryItem,
  oe as NavbarSection,
  Ae as NavbarSidebar
};
